module.exports = __webpack_public_path__ + "img/salonpas_lidocaine_4_pain_relieving_gel_patches_maximum_strength.476d4223.jpg";